import { cloudChiprApi } from "../../../../services/cloudchipr.api";

export const getUsersMeWorkflowsByWorkflowIdBatchesAndBatchIdResourcesSelector =
  cloudChiprApi.endpoints
    .getUsersMeWorkflowsByWorkflowIdBatchesAndBatchIdResources.select;
